import { render, staticRenderFns } from "./ClockDataNew.vue?vue&type=template&id=22c1552c"
import script from "./ClockDataNew.vue?vue&type=script&lang=js"
export * from "./ClockDataNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports